import React from 'react';
import PropTypes from 'prop-types';
import './ScriptActions.css';

const ScriptActions = ({ finalScript, copyToClipboard, downloadScript }) => {
  if (!finalScript) return null;
  return (
    <div className="script-actions">
      <div className="script-actions-header">
        <h4>Script Actions</h4>
        <p>Copy or download your generated script</p>
      </div>
      <div className="script-actions-buttons">
        <button onClick={copyToClipboard} className="btn-secondary">
          📋 Copy to Clipboard
        </button>
        <button onClick={downloadScript} className="btn-secondary">
          💾 Download Script
        </button>
      </div>
    </div>
  );
};

ScriptActions.propTypes = {
  finalScript: PropTypes.string.isRequired,
  copyToClipboard: PropTypes.func.isRequired,
  downloadScript: PropTypes.func.isRequired
};

export default ScriptActions; 